import { Header, Navigation } from '../partials/header';

export function NotLoggedIn() {
    return (
        <div className="theme-container">
            <Navigation />

            <div className="main-content">
                <Header />

                {/* Page Content */}
                <div className="page-content">
                    <div className="content-wrapper">
                        <h1 className="page-heading">
                            Please Log In to use Our Product
                        </h1>
                        <div className="content-card">
                            <h2 className="card-title">
                                Instructions
                            </h2>
                            <p className="card-text">
                                Click on the register button in the top right, then create an account. 
                                Sign in afterwards to see all that we have to offer!
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}